<template>
	<div class="footer">
		<media v-if="$route.path == '/' || $route.path == '/home' || $route.path == '/en' || $route.path == '/mt1' || $route.path == '/mt2' || $route.path == '/mt3' || $route.path == '/mt4' || $route.path == '/mt5'"></media>
		<div class="m">
			<div class="info">
				<div class="contact" :class="ExhibitDetail.uuid ? 'zhanlan-contact' : ''">
					<div class="left">
						<p v-if="ExhibitDetail.uuid">{{ contactlist['name' + En] }}</p>
						<template v-else>
							<img class="left-logo" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/logo.png" alt="">
							<div class="left-text">{{ $t('newbanner10') }}</div>
						</template>
						<ul>
							<li v-for="(v, i) in channellist.filter(x => En ? x.iconUrlEn : x.iconUrl)" :key="i">
								<img :src="En ? v.iconUrlEn : v.iconUrl" @mouseenter="mouseEnter(v, i)" />
								<div>
									<img :src="En ? (v.iconHoverUrlEn || v.qrCodeUrlEn) : (v.iconHoverUrl || v.qrCodeUrl)" />
								</div>
							</li>
						</ul>

						<div class="fontbox" v-if="!ExhibitDetail.uuid">
							<div v-for="(item, index) in contacts" :key="index">
								<span v-for="(ite, ind) in item" :key="ind" v-show="ite['label' + En]">
									<img class="icon" v-if="ind == 0" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/foot-icon1.png" alt="">
									<img class="icon" v-if="ind == 1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/foot-icon2.png" alt="">
									<img class="icon" v-if="ind == 2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/foot-icon3.png" alt="">
									{{ ite['label' + En] }}
								</span>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="link" :class="!ciiflist || !ciiflist.length ? 'no-org' : ''" v-if="ciiflist && ciiflist.length || ExhibitDetail.uuid">
							<div class="fontbox" v-if="ExhibitDetail.uuid">
								<div style="margin-right: 0">
									<div class="fontbox-item" v-for="(ite, ind) in contacts.names" :key="ind">
										<b>{{ ite['label' + En] }}</b>
										<div class="fontbox-item-text">
											<small>
												<img class="icon" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/foot-icon1.png" alt="">
												{{ contacts.phones[ind]['label' + En]  }}
											</small>
											<small>
												<img class="icon" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/foot-icon2.png" alt="">
												{{ contacts.mails[ind]['label' + En]  }}
											</small>
										</div>
									</div>
								</div>
							</div>
							<div class="link-right">
								<div class="label" v-for="(v, i) in ciiflist" :key="i">
									<p>{{ v['name' + En] }}</p>
									<ul>
										<li v-for="(c, ci) in (v.children || v.organizerList)" :key="ci" v-if="!c.hide">
											<a :href="c.link || c.linkUrl" target="_blank">{{ c['name' + En] }}</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="right-content" v-if="isPc">
							<div class="menu-content-top1" v-for="(v, i) in headList" v-if="!v.hide && v.children && v.children.length" :key="i">
								<a href="javascript:void(0)" @click="openLink(v, i)">{{ v['name' + En] }}</a>
								<template v-for="(c, ci) in v.children">
									<el-tooltip v-if="(c.name === '观众登记' || c.name === '媒体登记') && visitorIsClose" popper-class="expect-tooltips" effect="dark" :content="En ? 'Coming Soon' : '暂未开放 敬请期待'" placement="top-start">
										<div class="menu-content-top2">{{ c['name' + En] }}</div>
									</el-tooltip>
									<div v-else class="menu-content-top2" @click="openChlidren(c, i, c.name)">{{ c['name' + En] }}</div>
								</template>
							</div>
						</div>
						<div class="menu-content-top" v-else>
							<el-collapse v-model="activeNames">
								<el-collapse-item class="menu-content-top1" :class="activeNames.includes(i) ? 'active' : ''" v-for="(v, i) in headList" v-if="!v.hide && v.children && v.children.length" :key="i" :name="i">
									<template slot="title">
										<a href="javascript:void(0)">
											<span @click="openLink(v, i)">{{ v['name' + En] }}</span>
											<img v-if="activeNames.includes(i)" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/menu-icon-active.png" alt="">
											<img v-if="!activeNames.includes(i)" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/menu-icon.png" alt="">
										</a>
									</template>
									
									<template v-for="(c, ci) in v.children">
										<el-tooltip v-if="(c.name === '观众登记' || c.name === '媒体登记') && visitorIsClose" popper-class="expect-tooltips" effect="dark" :content="En ? 'Coming Soon' : '暂未开放 敬请期待'" placement="top-start">
											<div class="menu-content-top2">{{ c['name' + En] }}</div>
										</el-tooltip>
										<div v-else class="menu-content-top2" @click="openChlidren(c, i, c.name)">{{ c['name' + En] }}</div>
									</template>
								</el-collapse-item>
							</el-collapse>
						</div>
						<newsletter></newsletter>
					</div>
				</div>
			</div>
			<footer>
				<span style="flex: 1;"><a target="_blank" href="https://beian.miit.gov.cn">{{ $t('footer.footers') }}</a></span>
				<span>{{ $t('footer.footers1') }} <a @click.stop="$router.push('/match_process?pageType=policy')">{{ $t('footer.Policy') }}</a></span>
			</footer>
		</div>
	</div>
</template>

<script>
	import media from "./media.vue"
	import newsletter from "./newsletter.vue"
	import protal from "@/api/protal";
	import { mapState } from "vuex";
	export default {
		name: 'foots',
		components: {
			media,
			newsletter
		},
		data() {
			return {
				activeNames: [],
				ciiflist: [],
				contactlist: [],
				channellist: []
			}
		},
		computed: {
			...mapState({
				ExhibitDetail: state => state.ExhibitDetail,
			}),
			contacts() {
				return {
					names: this.names,
					phones: this.phones,
					mails: this.mails,
				}
			},
			names() {
				return this.contactlist && this.contactlist.children && this.contactlist.children.map(x => ({
					label: x.name,
					labelEn: x.nameEn
				}))
			},
			phones() {
				return this.contactlist && this.contactlist.children && this.contactlist.children.map(x => ({
					label: x.phone,
					labelEn: x.phoneEn
				}))
			},
			mails() {
				return this.contactlist && this.contactlist.children && this.contactlist.children.map(x => ({
					label: x.mail,
					labelEn: x.mailEn
				}))
			},
			headList() {
				return this.$store.state.headList || []
			}
		},
		created() {
			this.init()
			this.pageView('ciif_pageFoot')
		},
		watch: {
			ExhibitDetail: {
				handler() {
					this.init()
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			mouseEnter(v, i) {
				let strArr = ['ciif_pageFoot_qiyeWechat', 'ciif_pageFoot_wechat', 'ciif_pageFoot_videAccount', 'ciif_pageFoot_microblog', 'ciif_pageFoot_tiktok', 'ciif_pageFoot_bilibili', 'ciif_pageFoot_facebook']
				let nameArr = ['企业微信','微信','官方视频号','微博','抖音','哔哩哔哩','脸书']
				this.$jsAPI('track', 'ciif_pageFoot_all', {
					contentName_var: nameArr[i]
				})
				this.$jsAPI('track', strArr[i])
				if (this.ExhibitDetail && this.ExhibitDetail.uuid) {
					this.$jsAPI('track', 'ciif_gbzyExhibition_yinliiuList', {
						contentName_var: nameArr[i],
						exhibitionName_var: this.ExhibitDetail.name
					})
				}
			},
			init() {
				if(this.ExhibitDetail.uuid) {
					// 专业展底部
					this.ExhibitDetail.organizerTypeList
					this.ciiflist = this.ExhibitDetail.organizerTypeList
					this.contactlist = {
						name: '联系方式',
						nameEn: 'Contacts',
						children: this.ExhibitDetail.contactUsList
					}
					this.channellist = this.ExhibitDetail.iconInfoList
				} else {
					this.ciiflist = []
					// 主办单位等
					protal.getJson('ciif_sponsor_code', data => {
						this.ciiflist = data
					})
					// 联系我们
					protal.getJson('contact_us_code', data => {
						this.contactlist = data
					})
					// 联系渠道
					protal.getJson('channel_icon_code', data => {
						this.channellist = data
					})
				}
			},
			// 点击二级菜单
			openChlidren(c, i, leftIndex) {
				this.$jsAPI('track', 'ciif_pageHead_all', { contentName_var: '二级导航' })
				this.$jsAPI('track', 'ciif_pageHead_secondNavigation', {
					firstNavigationID_var: '无',
					firstNavigationName_var: this.headList[i].name,
					contentID_var: '无',
					contentName_var: c.name
				})
				
				let type = c.type
				
				if (type == 1 || type == 2) {
					this.$store.commit('setPageName', c)
					this.$store.commit('setLeftIndex', leftIndex)
					this.openLink({ link: '/match_process?code=' + c.code + '&pageType=homePage' }, i)
				} else if (type == 3) {
					window.open(c['outLink' + this.En] || c.outLink);
				} else if (type == 4) {
					window.open(c['fileUrl' + this.En] || c.outLink);
				} else {
					this.$store.commit('setLeftIndex', leftIndex)
					this.openLink(c, i)
				}
				this.mobileflag = false
			},
			// 点击一级菜单
			openLink(v, i) {
				this.showMenu = false
				this.$jsAPI('track', 'ciif_pageHead_all', { contentName_var: '一级导航' })
				this.$jsAPI('track', 'ciif_pageHead_firstNavigation', {
					contentID_var: '无',
					contentName_var: v.name
				})
				if (v.link) {
					this.$store.commit('setHeadIndex', i)
					if (v.query) {
						this.$router.push({ path: v.link, query: { ...v.query } })
					} else {
						this.$router.push({ path: v.link })
					}
					this.mobileflag = false
				} else {
					if (!this.isPc) {
						this.$store.commit('setHeadIndex', i)
					}
				}
			},
		}
	}
</script>

<style lang="less">
@media screen and (min-width: 769px) {
	.footer {
		overflow: hidden;
		width: 100%;
		position: relative;
		z-index: 999;
		background: #D3CFCC;
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/home2-bg.png);
		background-repeat: no-repeat;
		background-size: 100% auto;
		background-position: left bottom;
		background-color: #152B44;

		.cname {
			display: block;
			font-size: .14rem;
			line-height: .23rem;
			margin-bottom: .2rem;
			color: #4A4948;
		}
		.cphone {
			width: 1.1rem;
			display: inline-block;
		}
		&.on {
			.m {
				.info {
					display: block;
					.link {
						width: 100%;
						.label {
							ul {
								/*width: 100%;*/
							}
							ul li {
								/*width: 100%;*/
							}
						}
					}
				}
			}
		}
		footer {
			width: 1640px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: .16rem;
			color: #242424;
			border-top: 1px solid rgba(255, 255, 255, 0.2);
			box-sizing: border-box;
			font-family: syn;
			padding: .4rem 0 .6rem;
			span {
				margin: 0 .2rem;
				font-family: syn;
				color: rgba(255, 255, 255, 0.8) !important;

				a {
					color: rgba(255, 255, 255, 0.8) !important;
				}
			}
		}
		.m {
			.info {
				display: flex;
				justify-content: space-between;
				.contact {
					display: flex;
					align-items: flex-start;
					width: 1640px;
					margin: 0 auto;
					p {
						font-size: .23rem;
						color: #fff;
						line-height: 1;
						white-space: nowrap;
						font-family: syb;
					}
					.left {
						flex: 0 0 480px;
						margin-left: .32rem;
						padding: 100px 0 80px;

						.left-logo {
							width: 240px;
							height: auto;
							display: block;
						}

						.left-text {
							width: 360px;
							font-family: MiSans, MiSans;
							font-weight: 400;
							font-size: 16px;
							color: rgba(255, 255, 255, 0.6);
							line-height: 24px;
							text-align: left;
							font-style: normal;
							margin: 37px 0 72px;
						}

						.fontbox {
							overflow: hidden;
							display: flex;
							width: 450px;
							div {
								overflow: hidden;
								margin-right: .1rem;
								&:first-child span {
								}
								.icon {
									flex: 0 0 20px;
									height: 20px;
									transform: translateY(5px);
									margin-right: 20px;
									overflow: hidden;
								}
								span {
									display: flex;
									font-size: .16rem;
									color: #fff;
									font-family: syn;
									line-height: .24rem;
									margin-bottom: .16rem;

									&:last-child {
										margin-bottom: 0;
									}
								}
							}
						}
						ul {
							margin-bottom: 60px;

							display: flex;
							li {
								margin-right: 8px;
								cursor: pointer;
								line-height: .23rem;
								position: relative;
								&:hover {
									div {
										opacity: 1;
										visibility: inherit;
									}
								}
								&:last-child {
									margin-right: 0;
								}
								&>img {
									display: block;
									width: 44px;
									height: 44px;
									border-radius: 8px;
									box-sizing: border-box;
								}
								div {
									overflow: hidden;
									width: 1.3rem;
									padding: .1rem;
									background: #fff;
									position: absolute;
									left: 50%;
									visibility: hidden;
									opacity: 0;
									transition: all .1s;
									transform: translateX(-50%);
									top: -1.4rem;
									img {
										display: block;
										width: 100%;
									}
								}
							}
						}
					}

					.right {
						flex: 1;
						overflow: hidden;
						height: 100%;
						border-left: 1px solid rgba(255, 255, 255, 0.2);
						padding: 100px 0 0 100px;

						.right-content {
							display: flex;
						}

						.menu-content-top1 {
							flex: 0 0 226px;

							a {
								display: block;
								font-family: Inter, syn;
								font-weight: 500;
								font-size: 20px;
								color: #F4501C;
								line-height: 20px;
								text-align: left;
								font-style: normal;
								padding-bottom: 14px;
							}
						}

						.menu-content-top2 {
							font-family: Inter, syn;
							font-weight: 400;
							font-size: 16px;
							color: rgba(255, 255, 255, 0.8);
							line-height: 30px;
							padding: 5px 0;
							text-align: left;
							font-style: normal;
							cursor: pointer;
							position: relative;

							&:hover, &.active {

								&::after {
									content: "";
									position: absolute;
									left: 0;
									right: 0;
									bottom: 0;
									border-bottom: 1px solid #F4501C;
								}
							}
						}
					}

					&.zhanlan-contact {

						.left {
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							height: 100%;

							p {
								font-family: Inter, syn;
								font-weight: bold;
								font-size: 60px;
								color: #FFFFFF;
								line-height: 60px;
								font-style: normal;
								text-transform: uppercase;
								margin-bottom: 100px;
							}
						}

						.right {
							border-left: none;
						}
					}
				}
				.link {
					display: flex;
					width: 100%;

					.label {
						overflow: hidden;
						width: 100%;
						margin-bottom: 44px;

						p {
							font-family: Inter, syn;
							font-weight: 500;
							font-size: 20px;
							color: #F4501C;
							line-height: 20px;
							text-align: left;
							font-style: normal;
							margin-bottom: 28px;
						}
						ul {
							
							li {
								font-family: Inter, syn;
								font-weight: 400;
								font-size: 16px;
								color: #FFFFFF;
								line-height: 30px;
								text-align: left;
								font-style: normal;
								margin-bottom: 10px;

								&:hover a {
									color: #FC581C;
									text-decoration: underline;
								}
								a {
									display: block;
									transition: all .05s;
									font-family: syn;
									color: #fff;
								}
							}
						}
					}
				}
			}
		}
	}

	.link-right {
		flex: 1;
	}


	.fontbox-item {
		width: 360px;
		margin-right: 160px;
		margin-bottom: 44px;

		b {
			font-family: Inter, syn;
			font-weight: 500;
			font-size: 20px;
			color: #FFFFFF;
			line-height: 20px;
			text-align: left;
			font-style: normal;
			padding-bottom: 16px;
			border-bottom: 1px solid rgba(255, 255, 255, 0.12);
			display: block;
			margin-bottom: 20px;
		}

		small {
			font-family: Inter, syn;
			font-weight: 500;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 24px;
			text-align: left;
			font-style: normal;
			margin-bottom: 16px;
			display: flex;

			.icon {
				width: 20px;
				height: 20px;
				margin-right: 20px;
				overflow: hidden;
				transform: translateY(5px);
			}
		}
	}

	.no-org {

		.fontbox {
			width: 100%;

			&>div {
				display: flex;
				flex-wrap: wrap;
			}

			.fontbox-item {
				margin-right: 122px;
			}
		}

		.link-right {
			display: none;
		}
	}

	.en-wrapper {
		.footer .m .info .link .label {
			overflow: visible;
		}

		.footer .m .info .link .label p, .footer .m .info .contact p {
			display: flex;
			padding-right: 20px;
			white-space: nowrap;
		}

		.footer .m .info .contact .grow {
			margin-left: 0;
		}

		.footer .m .info .link {
			flex: 0 0 9rem;
		}

		.footer .m .info .contact .grow .fontbox div span {
			white-space: pre-wrap;
			color: #4A4948;
		}
	}
}

@media screen and (max-width: 768px) {
	.footer {
		overflow: hidden;
		width: 100%;
		position: relative;
		z-index: 9;
		background: #D3CFCC;
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/home2-bg.png);
		background-repeat: no-repeat;
		background-size: 100% auto;
		background-position: left bottom;
		background-color: #152B44;

		.cname {
			display: block;
			font-size: .14rem;
			line-height: .23rem;
			margin-bottom: .2rem;
			color: #4A4948;
		}
		.cphone {
			width: 1.1rem;
			display: inline-block;
		}
		&.on {
			.m {
				.info {
					display: block;
					.link {
						width: 100%;
						.label {
							ul {
								/*width: 100%;*/
							}
							ul li {
								/*width: 100%;*/
							}
						}
					}
				}
			}
		}
		footer {
			width: 6.78rem;
			margin: 0 auto;
			font-size: .24rem;
			line-height: .32rem;
			color: #242424;
			border-top: 1px solid rgba(255, 255, 255, 0.2);
			box-sizing: border-box;
			font-family: syn;
			padding: .4rem 0 .6rem;
			span {
				display: block;
				font-family: syn;
				color: rgba(255, 255, 255, 0.8) !important;
				margin-bottom: .2rem;

				a {
					color: rgba(255, 255, 255, 0.8) !important;
				}
			}
		}
		.m {
			.info {
				.contact {
					p {
						font-size: .23rem;
						color: #fff;
						line-height: 1;
						white-space: nowrap;
						font-family: syb;
					}
					.left {
						margin-left: .36rem;
						padding: .8rem 0;

						.left-logo {
							width: 2.4rem;
							height: auto;
							display: block;
						}

						.left-text {
							width: 6.78rem;
							font-family: Inter Regular, MiSans;
							font-weight: 400;
							font-size: .24rem;
							color: rgba(255, 255, 255, 0.6);
							line-height: .32rem;
							text-align: left;
							font-style: normal;
							margin: .32rem 0 .8rem;
						}

						.fontbox {
							div {
								overflow: hidden;
								margin-right: .1rem;
								&:first-child span {
								}
								.icon {
									flex: 0 0 .3rem;
									width: auto;
									height: .3rem;
									transform: translateY(.05rem);
									margin-right: .2rem;
									overflow: hidden;
								}
								span {
									display: flex;
									font-size: .24rem;
									color: #fff;
									font-family: syn;
									line-height: .36rem;
									margin-bottom: .24rem;

									&:last-child {
										margin-bottom: 0;
									}
								}
							}
						}
						ul {
							margin-bottom: .48rem;

							display: flex;
							li {
								margin-right: .2rem;
								cursor: pointer;
								line-height: .23rem;
								position: relative;
								&:hover {
									div {
										opacity: 1;
										visibility: inherit;
									}
								}
								&:last-child {
									margin-right: 0;
								}
								&>img {
									display: block;
									width: .68rem;
									height: .68rem;
									border-radius: .12rem;
									box-sizing: border-box;
								}
								div {
									overflow: hidden;
									width: 1.3rem;
									padding: .1rem;
									background: #fff;
									position: absolute;
									left: 50%;
									visibility: hidden;
									opacity: 0;
									transition: all .1s;
									transform: translateX(-50%);
									top: -1.4rem;
									img {
										display: block;
										width: 100%;
									}
								}
							}
						}
					}

					.right {

						.menu-content-top {
							padding: 0 0.36rem;

							.menu-content-top1 {

								a {
									width: 100%;
									display: block;
									font-family: syb;
									font-weight: 500;
									font-size: .32rem;
									color: #fff;
									line-height: .32rem;
									text-align: left;
									font-style: normal;
									position: relative;

									img {
										position: absolute;
										right: 0;
										top: 50%;
										transform: translateY(-50%);
										width: .28rem;
										height: .28rem;
										padding: .2rem;
										box-sizing: content-box;
									}
								}

								&.active {
									
									a {
										color: #F4501C;
									}
								}
							}

							.menu-content-top2 {
								font-family: syn;
								font-weight: 400;
								font-size: .28rem;
								color: rgba(255,255,255,0.8);
								line-height: .8rem;
								text-align: left;
								font-style: normal;
								cursor: pointer;
								position: relative;

								&:hover, &.active {
									color: #F4501C;
								}
							}

							.el-collapse {
								border: none;
								
								.el-collapse-item__header {
									background-color: transparent;
									border-color: rgba(255, 255, 255, 0.20);

									&.is-active {
										border-color: transparent;
									}

									.el-icon-arrow-right {
										display: none;
									}
								}

								.el-collapse-item__wrap {
									background-color: transparent;
									border-color: rgba(255, 255, 255, 0.20);
									
									.el-collapse-item__content {
										padding: 0 0 0.3rem;
									}
								}
							}
						}
					}

					&.zhanlan-contact {

						.left {
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							height: 100%;

							p {
								font-family: Inter, syn;
								font-weight: bold;
								font-size: .68rem;
								color: #FFFFFF;
								line-height: .68rem;
								font-style: normal;
								text-transform: uppercase;
								margin-bottom: .6rem;
							}
						}

						.right {
							border-left: none;
						}
					}
				}
				.link {
					width: 6.78rem;
					margin: -0.8rem auto 0;
					padding-top: .78rem;
					border-top: 1px solid rgba(255, 255, 255, 0.2);

					.label {
						overflow: hidden;
						width: 100%;
						margin-bottom: .4rem;

						p {
							font-family: Inter, syn;
							font-weight: 500;
							font-size: .28rem;
							color: #F4501C;
							line-height: .28rem;
							text-align: left;
							font-style: normal;
							margin-bottom: .28rem;
						}
						ul {
							
							li {
								font-family: Inter, syn;
								font-weight: 400;
								font-size: .24rem;
								color: #FFFFFF;
								line-height: .32rem;
								text-align: left;
								font-style: normal;
								margin-bottom: .1rem;

								&:hover a {
									color: #FC581C;
									text-decoration: underline;
								}
								a {
									display: block;
									transition: all .05s;
									font-family: syn;
									color: #fff;
								}
							}
						}
					}
				}
			}
		}
	}

	.link-right {
		margin-top: .8rem;
	}


	.fontbox-item {
		margin-bottom: .6rem;

		b {
			font-family: Inter, syn;
			font-weight: 500;
			font-size: .28rem;
			color: #FFFFFF;
			line-height: .28rem;
			text-align: left;
			font-style: normal;
			padding-bottom: .23rem;
			display: block;
			margin-bottom: .23rem;
			position: relative;

			&::after {
				content: "";
				position: absolute;
				left: 0;
				bottom: 0;
				width: .4rem;
				border-bottom: .04rem solid #F4501C;
			}
		}

		small {
			font-family: Inter, syn;
			font-weight: 500;
			font-size: .24rem;
			color: #FFFFFF;
			line-height: .24rem;
			text-align: left;
			font-style: normal;
			margin-bottom: .2rem;
			display: flex;

			.icon {
				display: none;
			}
		}
	}

	.no-org {

		.fontbox {
			width: 100%;

			&>div {
				display: flex;
				flex-wrap: wrap;
			}

			.fontbox-item {
				margin-right: 122px;
			}
		}

		.link-right {
			display: none;
		}
	}

	.en-wrapper {
		.footer .m .info .link .label {
			overflow: visible;
		}

		.footer .m .info .link .label p, .footer .m .info .contact p {
			display: flex;
			padding-right: 20px;
			white-space: nowrap;
		}

		.footer .m .info .contact .grow {
			margin-left: 0;
		}

		.footer .m .info .link {
			flex: 0 0 9rem;
		}

		.footer .m .info .contact .grow .fontbox div span {
			white-space: pre-wrap;
			color: #4A4948;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/foots.vue